var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:`container container-${_vm.theme}${
      _vm.hasFixedButton ? ' container-fixed-button' : ''
    } layout-${_vm.layout}`},[_c('wrap-container',{staticClass:"w100"},[_c('p',{staticClass:"title",on:{"click":_vm.toggleText}},[_vm._v("Términos y condiciones")]),_c('footer',[_c('transition',{attrs:{"name":"fade"}},[(_vm.isTextVisible)?_vm._t("default"):_vm._e()],2)],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }